import { React, useEffect } from 'react'

const Calendar = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/toriiGate.jpg")'; // Set background image for the Calendar page
        return () => { document.body.style.backgroundImage = 'none'; }; // Clean up function to reset background image on unmount
    }, []);
    return (
        <div>
            <div>Calendar</div>
            <hr />
            <div className="flex justify-center items-center">
                <iframe 
                    title="Google Calendar" 
                    src="https://calendar.google.com/calendar/embed?src=21d88dbd9173fe6af48422c0d2435ae8635ddba1d8e2e6019a476f25cbe93768%40group.calendar.google.com&ctz=America%2FChicago" 
                    style={{ border: 0 }} 
                    width="800" 
                    height="600" 
                    frameBorder="0" 
                    scrolling="no">
                </iframe>
            </div>
        </div>
    )
}

export default Calendar